var React = require('react');

function IconCommit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M701.6 478.2c-15.6-90.4-94.4-159.1-189.2-159.1s-173.6 68.8-189.2 159.1H73.3c-5.5 0-10 4.5-10 10v44c0 5.5 4.5 10 10 10h249.6c14.9 91.2 94 160.8 189.5 160.8S687 633.4 701.9 542.2h247.4c5.5 0 10-4.5 10-10v-44c0-5.5-4.5-10-10-10H701.6zM512.4 608.7c-53.9 0-97.7-43.7-97.7-97.7s43.7-97.7 97.7-97.7 97.7 43.7 97.7 97.7-43.7 97.7-97.7 97.7z"}));
}

IconCommit.displayName = "IconCommit";

IconCommit.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCommit;

IconCommit.default = IconCommit;
